import Vue from 'vue'
import Router from 'vue-router'
import Middleware from './middleware.js'

const Product = () => import('@/components/shop/product')
// const ProductList = () => import('@/components/shop/product/list')
const ProductInfo = () => import('@/components/shop/product/info')
const CategoryInfo = () => import('@/components/shop/category/info')
const CategorySort = () => import('@/components/shop/category/sort')
const Unauthorized = () => import('@/components/share/unauthorized')
const Login = () => import('@/components/login')
const Order = () => import('@/components/shop/order')
const Settings = () => import('@/components/shop/settings')

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/401',
      name: 'Unauthorized',
      component: Unauthorized
    },
    {
      path: '/',
      name: 'Home',
      component: Product
    },
    {
      path: '/product/list',
      name: 'ProductList',
      props: true,
      component: Product
    },
    {
      path: '/product/add/:categoryId',
      name: 'ProductAdd',
      props: true,
      component: ProductInfo
    },
    {
      path: '/product/edit/:productId',
      name: 'ProductEdit',
      props: true,
      component: ProductInfo
    },
    {
      path: '/category/add/:categoryParentId',
      name: 'CategoryAdd',
      props: true,
      component: CategoryInfo
    },
    {
      path: '/category/edit/:categoryId',
      name: 'CategoryEdit',
      props: true,
      component: CategoryInfo
    },
    {
      path: '/category/sort/:categoryId',
      name: 'CategorySort',
      props: true,
      component: CategorySort
    },
    {
      path: '/login/:authToken',
      name: 'login',
      props: true,
      component: Login
    },
    {
      path: '/loginRMP/:authToken/:rmpToken',
      name: 'loginRMP',
      props: true,
      component: Login
    },
    {
      path: '/login/:authToken/:language',
      name: 'loginSpecificLanguage',
      props: true,
      component: Login
    },
    {
      path: '/order',
      name: 'order',
      component: Order
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings
    },
    {
      path: '/settings/:currentViewProp',
      name: 'settingsProp',
      props: true,
      component: Settings
    }
  ]
})

router.beforeEach((to, from, next) => {
  Middleware.globalBeforeEachRouter(to, from, next)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js